<template>
  <div class="bg">
    <div class="content">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-gerenxinxi" />
                基础信息
              </template>
              <el-form-item label="照片：">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :http-request="uploadPic"
                  accept="image/*"
                  capture="camera"
                  :show-file-list="false"
                  :on-change="handlePictureCardPreviewCollectionPhotos"
                >
                  <!-- :before-upload="beforeAvatarUpload" -->
                  <el-image
                    v-if="collectionPhotos"
                    :src="collectionPhotos"
                    fit="contain"
                    class="avatar"
                  >
                  </el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <!-- <span style="font-size: 12px">
                    <i style="color: red">*</i>
                    只能上传jpg/png格式大头照，且不超过2MB
                  </span> -->
                </el-upload>
              </el-form-item>
              <el-form-item label="姓名：">
                <el-input size="small" v-model="infoForm.name" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="性别：">
                <el-input size="small" v-model="infoForm.sex" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="民族：">
                <el-input size="small" v-model="infoForm.nation" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="文化程度：">
                <span @click="showCultureLevelTypePopup = true">
                  {{ cultureLevelType }}
                </span>
                <van-popup
                  v-model="showCultureLevelTypePopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择文化程度"
                    show-toolbar
                    :columns="cultureLevelTypeOptions"
                    @confirm="onConfirmCultureLevelType"
                    @cancel="showCultureLevelTypePopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="政治面貌：">
                <span @click="showPoliticCountenancePopup = true">
                  {{ politicCountenance }}
                </span>
                <van-popup
                  v-model="showPoliticCountenancePopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择政治面貌"
                    show-toolbar
                    :columns="politicCountenanceOptions"
                    @confirm="onConfirmPoliticCountenance"
                    @cancel="showPoliticCountenancePopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="出生日期：">
                <el-input size="small" v-model="infoForm.birthday" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="手机号码：">
                <el-input size="small" v-model="infoForm.phone" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="家庭住址：">
                <el-input
                  size="small"
                  type="textarea"
                  v-model="infoForm.address"
                  :disabled="true"
                  autosize
                >
                </el-input>
              </el-form-item>
              <el-form-item label="证件类型：">
                <el-input size="small" v-model="idCardType" :disabled="true"> </el-input>
              </el-form-item>
              <el-form-item label="证件号码：">
                <el-input size="small" v-model="infoForm.idCardNumber" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="签发机关：">
                <el-input size="small" v-model="infoForm.iddepart" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="有效期限：">
                <el-input size="small" v-model="infoForm.effectiveDate" :disabled="true">
                </el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-jichuxinxi" />
                进场信息
              </template>
              <el-form-item label="工号：">
                <el-input size="small" v-model="infoForm.jobNo" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="所属项目：">
                <el-input size="small" v-model="projectId" :disabled="true"> </el-input>
              </el-form-item>
              <el-form-item label="所属企业：">
                <el-input size="small" v-model="infoForm.unitId" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="所属班组：">
                <el-input size="small" v-model="teamId" :disabled="true"> </el-input>
              </el-form-item>
              <el-form-item label="人员类型：">
                <span @click="showPersonnelTypePopup = true">
                  {{ personnelType }}
                </span>
                <van-popup
                  v-model="showPersonnelTypePopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择人员类型"
                    show-toolbar
                    :columns="personnelTypeOptions"
                    @confirm="onConfirmPersonnelType"
                    @cancel="showPersonnelTypePopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item
                v-if="personnelType !== '建筑工人' && personnelType !== '请选择人员类型'"
                label="管理岗位："
                prop="post"
              >
                <span v-if="post !== '请选择管理岗位'" @click="showPostPopup = true">
                  {{ post }}
                </span>
                <span v-else @click="showPostPopup = true">
                  {{ form.post }}
                </span>
                <van-popup
                  v-model="showPostPopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择人员类型"
                    show-toolbar
                    :columns="postOptions"
                    @confirm="onConfirmPost"
                    @cancel="showPostPopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="所属工种：" prop="workType">
                <span v-if="form.workType == ''" @click="showWorkTypePopup = true">
                  {{ workType }}
                </span>
                <span v-else @click="showWorkTypePopup = true">
                  {{ form.workType }}
                </span>
                <van-popup
                  v-model="showWorkTypePopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择所属工种"
                    show-toolbar
                    :columns="workTypeOptions"
                    @confirm="onConfirmWorkType"
                    @cancel="showWorkTypePopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="当前状态：">
                <el-input size="small" v-model="status" :disabled="true"> </el-input>
              </el-form-item>
              <el-form-item label="工作性质：">
                <span @click="showCategoryPopup = true">
                  {{ category }}
                </span>
                <van-popup
                  v-model="showCategoryPopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择工作性质"
                    show-toolbar
                    :columns="categoryOptions"
                    @confirm="onConfirmCategory"
                    @cancel="showCategoryPopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="签订合同：">
                <span @click="showHasContractPopup = true">
                  {{ hasContract }}
                </span>
                <van-popup
                  v-model="showHasContractPopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择是否已签订合同"
                    show-toolbar
                    :columns="hasContractOptions"
                    @confirm="onConfirmHasContract"
                    @cancel="showHasContractPopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="购买保险：">
                <span @click="showHasBuyInsurancePopup = true">
                  {{ hasBuyInsurance }}
                </span>
                <van-popup
                  v-model="showHasBuyInsurancePopup"
                  round
                  position="bottom"
                  :style="{
                    height: 45,
                  }"
                >
                  <van-picker
                    title="请选择是否已购买保险"
                    show-toolbar
                    :columns="hasBuyInsuranceOptions"
                    @confirm="onConfirmHasBuyInsurance"
                    @cancel="showHasBuyInsurancePopup = false"
                  />
                </van-popup>
              </el-form-item>
              <el-form-item label="进场时间：">
                <el-input size="small" v-model="infoForm.entryTime" :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="退场时间：">
                <el-input size="small" v-model="infoForm.exitTime" :disabled="true">
                </el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="3">
              <template slot="title">
                <i class="iconfont icon-jichuxinxi" />
                其他
              </template>
              <el-form-item label="备注信息：">
                <el-input size="small" type="textarea" v-model="infoForm.remark">
                </el-input>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </el-form>
      <div class="btn">
        <el-button type="info" @click="quitBtn" size="mini"> 取消 </el-button>
        <el-button type="primary" size="mini" @click="submitForm('infoForm')">
          提交
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { postFile } from "@/api/file";
import { compress } from "@/utils/file";
import { postDictCode } from "@/api/dict";
import { filtration$ } from "@/utils/admin";
import { postListUnit } from "@/api/app/unit";
import { postTeamDetail } from "@/api/app/team";
import { postProjectId } from "@/api/app/project";
import { postRecruitEssentialInfoFile } from "@/api/file";
import { postDetail, postSubmitForm } from "@/api/app/roster";
let collectionPhotosSuccess = 0;
export default {
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      // 所属项目
      projectId: "",
      // 班组
      teamId: "",
      // 采集照片
      collectionPhotos: "",
      // 居民身份证
      idCardType: "",
      // 文化程度
      cultureLevelType: "",
      // 在场
      status: "",
      showCultureLevelTypePopup: false,
      cultureLevelTypeOptions: [],
      // 政治面貌
      politicCountenance: "",
      showPoliticCountenancePopup: false,
      politicCountenanceOptions: [],
      // 人员类型
      personnelType: "请选择人员类型",
      showPersonnelTypePopup: false,
      personnelTypeOptions: [
        { text: "管理人员", value: 10 },
        { text: "建筑工人", value: 20 },
      ],
      // 管理岗位
      post: "请选择管理岗位",
      showPostPopup: false,
      postOptions: [],
      // 所属工种
      workType: "请选择工种",
      showWorkTypePopup: false,
      workTypeOptions: [],
       initialWorkType:"",
      // 工作性质
      category: "",
      showCategoryPopup: false,
      categoryOptions: [
        { text: "合同工", value: 2 },
        { text: "临时工", value: 1 },
      ],
      // 签订合同
      hasContract: "",
      showHasContractPopup: false,
      hasContractOptions: [
        { text: "已签订", value: 1 },
        { text: "未签订", value: 2 },
      ],
      // 购买保险
      hasBuyInsurance: "",
      showHasBuyInsurancePopup: false,
      hasBuyInsuranceOptions: [
        { text: "已购买", value: 1 },
        { text: "未购买", value: 2 },
      ],
      form: {
        post: "",
        workType: "",
      },
      infoForm: {},
      rules: {
        post: [{ required: true, message: "管理岗位不能为空" }],
        workType: [{ required: true, message: "所属工种不能为空" }],
      },
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    this.detail();
  },
  methods: {
    // 获取详情
    detail() {
      postDetail(this.$store.state.app.itemId).then((a) => {
        this.infoForm = a.data;
        this.collectionPhotos = a.data.collectionPhotos;
        delete this.infoForm.collectionPhotos;
        // // 人员类型
        if (a.data.personnelType == 10) {
          this.personnelType = "管理人员";
        } else if (a.data.personnelType == 20) {
          this.personnelType = "建筑工人";
        }
        // 工作性质
        if (a.data.category == 2) {
          this.category = "合同工";
        } else if (a.data.category == 1) {
          this.category = "临时工";
        }
        // 签订合同
        if (a.data.hasContract == 1) {
          this.hasContract = "已签订";
        } else if (a.data.hasContract == 2) {
          this.hasContract = "未签订";
        }
        // 购买保险
        if (a.data.hasBuyInsurance == 1) {
          this.hasBuyInsurance = "已购买";
        } else if (a.data.hasBuyInsurance == 2) {
          this.hasBuyInsurance = "未购买";
        }
        // 文化程度
        postDictCode("education_type").then((b) => {
          this.cultureLevelTypeOptions = b.data.map((item) => {
            return { text: item.label, ...item };
          });
          b.data.find((item) => {
            if (item.value == a.data.cultureLevelType) {
              this.cultureLevelType = item.label;
            }
          });
        });
        // 政治面貌
        postDictCode("outlook_type").then((b) => {
          this.politicCountenanceOptions = b.data.map((item) => {
            return { text: item.label, ...item };
          });
          b.data.find((item) => {
            if (item.value == a.data.politicCountenance) {
              this.politicCountenance = item.label;
            }
          });
        });
        // 证件类型
        postDictCode("certificate_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.idCardType) {
              this.idCardType = item.label;
            }
          });
        });
        // 所属项目
        postProjectId(a.data.projectId).then((b) => {
          this.projectId = b.data.name;
        });
        // 所属企业
        postListUnit(a.data.projectId).then((b) => {
          b.data.find((item) => {
            if (a.data.unitId == item.id) {
              this.infoForm.unitId = item.title;
            }
          });
        });
        // 所属班组
        postTeamDetail(a.data.teamId).then((b) => {
          this.teamId = b.data.name;
        });
        // 管理岗位
        postDictCode("management_type").then((b) => {
          this.postOptions = b.data.map((item) => {
            return { text: item.label, ...item };
          });

          if (this.personnelType !== "建筑工人") {
            b.data.find((item) => {
              if (item.value == a.data.post) {
                this.form.post = item.label;
              }
            });
          } else {
            this.post = "请选择所属管理岗位";
          }
        });
        // 所属工种
        postDictCode("work_type").then((b) => {
          this.workTypeOptions = b.data.map((item) => {
            return { text: item.label, ...item };
          });
          if (this.personnelType == "建筑工人") {
            b.data.find((item) => {
              if (item.value == a.data.workType) {
                this.form.workType = item.label;
                this.initialWorkType=item.label;
              }
            });
          } else if(this.personnelType == "管理人员") {
            b.data.find((item)=>{
              if(item.label=='管理人员'){
                // this.workType=item.label;
                this.form.workType=item.label;
              }
            })
          }
        });
        // 当前状态
        this.$store.state.app.dict.find((item) => {
          if (item.value == a.data.status) {
            this.status = item.label;
          }
        });
      });
    },
    // 照片上传后回显
    uploadPic() {},
    handlePictureCardPreviewCollectionPhotos(file) {
      if (file.status == "ready") {
        let _that = this;
        let params = {};
        params.format = "jpeg";
        params.folderName = "big_head_photo";
        const isLt10M = file.size / 1024 / 1024 < 15;
        const isLt1M = file.size / 1021 / 1024 < 1;
        if (!isLt10M) {
          _that.$notify({ type: "error", message: "上传图片大小不能超过 15M！" });
          return false;
        } else if (isLt1M) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = (e) => {
            if (e.currentTarget.result.search("png") !== -1) {
              params.format = "png";
              let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
              params.content = base64;
            }
            if (e.currentTarget.result.search("jpeg") !== -1) {
              params.format = "jpeg";
              let base64 = e.currentTarget.result.replace("data:image/jpeg;base64,", "");
              params.content = base64;
            }
            postFile(params).then((res) => {
              if (res.code == 200) {
                _that.collectionPhotos = res.data.url;
                _that.infoForm["collectionPhotos"] = res.data.path;
                _that.$notify({ type: "success", message: "照片选择成功！" });
                collectionPhotosSuccess = 1;
              } else {
                _that.$notify({ type: "error", message: "照片选择失败！请重新选择。" });
              }
            });
          };
        } else {
          this.collectionPhotos = URL.createObjectURL(file.raw);
          compress(file.raw, function (val) {
            let newFile = new window.File([val], file.name, { type: file.raw.type });
            newFile.uid = file.uid;
            let reader = new FileReader();
            reader.readAsDataURL(newFile);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  // _that.collectionPhotos = res.data.url;
                  _that.infoForm["collectionPhotos"] = res.data.path;
                  _that.$notify({ type: "success", message: "照片选择成功！" });
                  collectionPhotosSuccess = 1;
                } else {
                  _that.$notify({ type: "error", message: "照片选择失败！请重新选择。" });
                }
              });
            };
          });
        }
      }
    },
    // 文化程度
    onConfirmCultureLevelType(value) {
      this.cultureLevelType = value.label;
      this.infoForm.cultureLevelType = value.value;
      this.showCultureLevelTypePopup = false;
    },
    // 政治面貌选项
    onConfirmPoliticCountenance(value) {
      this.politicCountenance = value.label;
      this.infoForm.politicCountenance = value.value;
      this.showPoliticCountenancePopup = false;
    },
    // 人员类型
    onConfirmPersonnelType(value) {
      this.personnelType = value.text;
      this.infoForm.personnelType = value.value;
      this.showPersonnelTypePopup = false;
      this.workTypeOptions.find((item) => {
        if (value.value == 10) {
          if (item.label == "管理人员") {
            this.form.workType = item.text;
            this.infoForm.workType = item.value;
          }
        } else if (value.value == 20) {
          this.form.workType = this.initialWorkType;
        }
      });
    },
    // 管理岗位
    onConfirmPost(value) {
      this.post = value.text;
      this.form.post = value.text;
      this.infoForm.post = value.value;
      this.showPostPopup = false;
    },
    // 所属工种
    onConfirmWorkType(value) {
      this.form.workType = value.text;
      this.infoForm.workType = value.value;
      this.showWorkTypePopup = false;
    },
    // 工作性质
    onConfirmCategory(value) {
      this.category = value.text;
      this.infoForm.category = value.value;
      this.showCategoryPopup = false;
    },
    // 签订合同
    onConfirmHasContract(value) {
      this.hasContract = value.text;
      this.infoForm.hasContract = value.value;
      this.showHasContractPopup = false;
    },
    // 购买保险
    onConfirmHasBuyInsurance(value) {
      this.hasBuyInsurance = value.text;
      this.infoForm.hasBuyInsurance = value.value;
      this.showHasBuyInsurancePopup = false;
    },
    // 提交表单
    submitForm(infoForm) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          delete this.infoForm.unitId;
          postSubmitForm(filtration$(this.infoForm))
            .then((res) => {
              if (res.code == 200) {
                this.$notify({ type: "success", message: "修改成功！" });
                this.$router.back();
              }
            })
            .catch((error) => {
              this.$store.dispatch("submitToken");
            });
        }
      });
      //
    },
    //取消按钮
    quitBtn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 40px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.btn {
  text-align: right;
  margin-bottom: 10px;
}
.content {
  .el-card {
    margin-bottom: 10px;
    .el-form-item {
      margin-bottom: 5px;
    }
    span {
      font-size: 14px;
    }
    .img {
      img {
        width: 130px;
        height: 130px;
        border-radius: 4px;
      }
    }
  }
}
</style>
